import { render, staticRenderFns } from "./InventoryIn.vue?vue&type=template&id=98db29a4&scoped=true"
import script from "./InventoryIn.vue?vue&type=script&lang=js"
export * from "./InventoryIn.vue?vue&type=script&lang=js"
import style0 from "./InventoryIn.vue?vue&type=style&index=0&id=98db29a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98db29a4",
  null
  
)

export default component.exports